var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 6.5H4.999C4.72286 6.5 4.499 6.72386 4.499 7C4.499 7.27614 4.72286 7.5 4.999 7.5H10.999C11.2751 7.5 11.499 7.27614 11.499 7C11.499 6.72386 11.2751 6.5 10.999 6.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.999 8.5H9.999C10.2751 8.5 10.499 8.72386 10.499 9C10.499 9.27614 10.2751 9.5 9.999 9.5H4.999C4.72286 9.5 4.499 9.27614 4.499 9C4.499 8.72386 4.72286 8.5 4.999 8.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73223 4.73223C3.20107 4.26339 3.83696 4 4.5 4H11.5C12.163 4 12.7989 4.26339 13.2678 4.73223C13.7366 5.20107 14 5.83696 14 6.5V9.5C14 10.163 13.7366 10.7989 13.2678 11.2678C12.7989 11.7366 12.163 12 11.5 12H7.18643L4.8503 13.8568C4.7066 13.9979 4.49226 14.039 4.30655 13.9611C4.12083 13.8831 4 13.7014 4 13.5V11.9495C3.52328 11.8522 3.08142 11.617 2.73223 11.2678C2.26339 10.7989 2 10.163 2 9.5V6.5C2 5.83696 2.26339 5.20107 2.73223 4.73223ZM4.5 5C4.10218 5 3.72064 5.15804 3.43934 5.43934C3.15804 5.72064 3 6.10218 3 6.5V9.5C3 9.89783 3.15804 10.2794 3.43934 10.5607C3.72064 10.842 4.10218 11 4.5 11C4.77614 11 5 11.2239 5 11.5V12.7453L6.6317 11.1432C6.72519 11.0514 6.85098 11 6.982 11H11.5C11.8978 11 12.2794 10.842 12.5607 10.5607C12.842 10.2794 13 9.89782 13 9.5V6.5C13 6.10218 12.842 5.72064 12.5607 5.43934C12.2794 5.15804 11.8978 5 11.5 5H4.5Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.d65e94fd.svg";
export { ForwardRef as ReactComponent };